export default __webpack_public_path__ + "static/media/homedialysis01.dd2bcb47.png";